import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Container, Link, Stack, Typography } from '@mui/material';
import { colors, uiFont } from '../theme';
import { SITE_CONFIG, buildWhatsAppUrl } from '../config/site';
import Social from './Social';
import logo from '../assets/logoFinal-mark-96.webp';

const linkSx = {
  color: colors.secondary, fontSize: '0.82rem', lineHeight: 1.6, width: 'fit-content',
  '&:hover': { color: colors.accent },
};

const groups = [
  { title: 'Catalogo', links: [
    { label: 'Vinilos', to: '/vinilos' },
    { label: 'CDs', to: '/cds' },
    { label: 'Ultimos ingresos', href: '/#ultimos-ingresos' },
  ] },
  { title: 'Contacto', links: [
    { label: 'WhatsApp', href: buildWhatsAppUrl() },
    { label: 'Instagram', href: SITE_CONFIG.instagramUrl },
  ] },
  { title: 'Marca', links: [
    { label: 'Academia', to: '/academia' },
    { label: 'FAQs', to: '/faqs' },
    { label: 'Contacto', to: '/contact' },
  ] },
];

function Footer() {
  return (
    <Box component="footer" sx={{
      py: { xs: 2, md: 2.5 }, background: 'linear-gradient(145deg, var(--dxd-elevated), var(--dxd-surface))',
      borderTop: '1px solid rgba(255,255,255,0.04)',
    }}>
      <Container>
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'repeat(3, minmax(0, 1fr))', md: 'minmax(0, 2fr) repeat(3, minmax(0, 1fr))' }, gap: { xs: 2, md: 2.5 } }}>
          <Box sx={{ gridColumn: { xs: '1 / -1', md: 'auto' } }}>
            <Link component={RouterLink} to="/" aria-label="DiscoXDiscos, inicio" sx={{ display: 'inline-flex', mb: 1 }}>
              <Box component="img" src={logo} alt="" width={48} height={48} sx={{ objectFit: 'contain' }} />
            </Link>
            <Typography variant="body2" sx={{ color: colors.secondary, maxWidth: 330, lineHeight: 1.6, fontSize: '0.82rem' }}>
              Tienda de vinilos y CDs con escucha, consulta directa y música sin algoritmos.
            </Typography>
          </Box>
          {groups.map(({ title, links }) => (
            <Box component="nav" aria-label={title + ' en el footer'} key={title}>
              <Typography component="h2" sx={{ fontFamily: uiFont, fontSize: '0.7rem', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.06em', mb: 1, color: colors.text }}>
                {title}
              </Typography>
              <Stack spacing={0.5}>
                {links.map(({ label, to, href }) => (
                  <Link key={label} component={to ? RouterLink : 'a'} to={to} href={href}
                    target={href?.startsWith('https:') ? '_blank' : undefined} rel={href?.startsWith('https:') ? 'noreferrer' : undefined}
                    underline="none" sx={linkSx}>
                    {label}
                  </Link>
                ))}
              </Stack>
            </Box>
          ))}
        </Box>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: { xs: 'flex-start', md: 'center' }, justifyContent: 'space-between', gap: 1, mt: 2 }}>
          <Typography variant="caption" sx={{ color: colors.muted, fontSize: '0.65rem', letterSpacing: 0.6 }}>
            © {new Date().getFullYear()} DISCOXDISCOS
          </Typography>
          <Social />
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
